import styled from 'styled-components'

export const h1 = styled.h1`
  font-family: ${(props) => props.theme.typography.fontFamily};
  text-transform: none;
  font-size: 22px;
  font-weight: 600;

  @media (min-width: 1200px) {
    font-size: 26px;
  }
`

export const h2 = styled.h2`
  font-family: ${(props) => props.theme.typography.fontFamily};
  text-transform: none;
  font-size: 20px;
`

export const h3 = styled.h3`
  font-family: ${(props) => props.theme.typography.fontFamily};
  text-transform: none;
  font-size: 18px;
`

export const h4 = styled.h4`
  font-family: ${(props) => props.theme.typography.fontFamily};
  text-transform: none;
`

export const h5 = styled.h5`
  font-family: ${(props) => props.theme.typography.fontFamily};
  text-transform: none;
`

export const h6 = styled.h6`
  font-family: ${(props) => props.theme.typography.fontFamily};
  text-transform: none;
`

export const PanelHeader = styled.h1`
  font-family: ${(props) => props.theme.typography.fontFamily};
  text-transform: none;
  font-size: 16px;
  font-weight: 700;

  @media (min-width: 768px) {
    font-size: 26px;
    font-weight: 500;
  }
`
